/* eslint-disable @typescript-eslint/no-unused-vars */
import sendFetch from 'common/utils/fetch';
import { useEffect, useState } from 'react';
import { FullItem } from '../pages/OrderProductSettings';
import { AttachedPhoto } from '../types/OrderServiceItem';

export type ParamCardProps = {
  id: string | number;
  name: string;
  price?: number;
  legalPrice?: number;
};
export const useFetchServiceParams = (selectedCategory: string | number, searchValue: string, selectedItem?: FullItem, refresh?:boolean) => {
  const [cardLineCount, setCardLineCount] = useState(1);
  const [itemList, setItemList] = useState([] as FullItem[]);
  const [searchedList, setSearchedList] = useState([] as FullItem[]);
  const [isSearch, setIsSearch] = useState(false);
  const [varName, setVarName] = useState('' as string);
  const [fetchLink, setFetchLink] = useState('' as string);
  const [hasSlider, setHasSlider] = useState(false);
  const [isCustom, setIsCustom] = useState(false);
  const [photoList, setPhotoList] = useState([] as AttachedPhoto[]);
  useEffect(() => {
    console.log(`selectedCategory: ${selectedCategory}`);
    if (selectedItem.type === 'service') {
      switch (selectedCategory) {
        case 1:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-additional-services');
          setCardLineCount(2);
          setIsSearch(false);
          setHasSlider(false);
          setVarName('adServiceId');
          setIsCustom(false);
          break;
        case 2:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-processing-type');
          setCardLineCount(2);
          setIsSearch(true);
          setHasSlider(false);
          setVarName('processingTypesId');
          setIsCustom(false);
          break;
        case 3:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-brands');
          setCardLineCount(3);
          setIsSearch(true);
          setHasSlider(false);
          setVarName('brandsId');
          setIsCustom(false);
          break;
        case 4:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-colors');
          setCardLineCount(3);
          setIsSearch(true);
          setHasSlider(false);
          setVarName('colorsId');
          setIsCustom(false);
          break;
        case 5:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-accessories-and-decor');
          setCardLineCount(3);
          setIsSearch(true);
          setHasSlider(false);
          setVarName('acDecorId');
          setIsCustom(false);
          break;
        case 6:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-defects');
          setCardLineCount(3);
          setIsSearch(true);
          setHasSlider(true);
          setVarName('defectsId');
          setIsCustom(false);
          break;
        case 7:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-origin-of-stains');
          setCardLineCount(3);
          setIsSearch(true);
          setHasSlider(false);
          setVarName('originStainsId');
          setIsCustom(false);
          break;
        case 8:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-spots-location');
          setCardLineCount(3);
          setIsSearch(true);
          setHasSlider(false);
          setVarName('spotsLocationId');
          setIsCustom(false);
          break;
        case 9:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-admission-conditions');
          setCardLineCount(2);
          setIsSearch(false);
          setHasSlider(false);
          setVarName('adConditionsId');
          setIsCustom(false);
          break;
        case 10:
          setVarName('attachedPhotos');
          setPhotoList(selectedItem.attachedPhotos || []);
          setIsCustom(true);
          break;
        case 11:
          setVarName('other');
          setIsCustom(true);
          break;
      }
    } else if (selectedItem.type === 'product') {
      switch (selectedCategory) {
        case 1:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-product-size');
          setCardLineCount(3);
          setIsSearch(true);
          setHasSlider(false);
          setVarName('productSizeId');
          setIsCustom(true);
          break;
        case 2:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-colors');
          setCardLineCount(3);
          setIsSearch(true);
          setHasSlider(false);
          setVarName('productColorsId');
          setIsCustom(false);
          break;
        case 3:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-product-material');
          setCardLineCount(3);
          setIsSearch(true);
          setHasSlider(false);
          setVarName('productMaterialId');
          setIsCustom(false);
          break;
        case 4:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-product-form');
          setCardLineCount(3);
          setIsSearch(false);
          setHasSlider(false);
          setVarName('productFormId');
          setIsCustom(false);
          break;
        case 5:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-product-coating');
          setCardLineCount(3);
          setIsSearch(false);
          setHasSlider(false);
          setVarName('productCoatingId');
          setIsCustom(false);
          break;
        case 6:
          setFetchLink('https://api-workspace.astin.net/api/get-nomenclature/get-defects');
          setCardLineCount(3);
          setIsSearch(false);
          setHasSlider(false);
          setVarName('other');
          setIsCustom(true);
          break;
      }
    }
  }, [selectedCategory]);
  useEffect(()=>{
    setPhotoList(selectedItem.attachedPhotos || []);
  }, [selectedItem, refresh]);
  useEffect(() => {
    const fetchParams = async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await sendFetch(fetchLink, { method: 'GET' });
      console.log(response);
      if (response && response[0] === 200 && response[1].statusCode === 200) {
        setItemList(response[1].list);
      }
    };
    fetchParams();
  }, [fetchLink]);
  useEffect(()=> {
    console.log(searchValue);
    const filteredList = itemList.filter((item: FullItem) => {
      return item.name.toLowerCase().includes(searchValue.toLowerCase());
    });
    setSearchedList(filteredList);
  }, [searchValue, itemList]);
  return { cardLineCount, itemList, searchedList, isSearch, varName, hasSlider, isCustom, photoList };
};
